module.exports = __webpack_public_path__ + "img/yxkhead.c804f38b.svg";